// Layout constants for aspect ratio calculation
export const LAYOUT_OVERHEAD = 64; // Description (16) + gaps (12 + 8) + padding top (12) + bottom (16)
export const MIN_PREVIEW_HEIGHT = 80; // Minimum height before max cropping
export const MIN_ASPECT_RATIO = 1; // 1:1 square (no crop)
export const MAX_ASPECT_RATIO = 3; // 3:1 wide (max crop)
export const DEFAULT_UPLOAD_HEIGHT = 140; // Fallback if upload section not measured
